import * as S from './styles';
import { RiCalendarTodoLine, RiBookReadLine } from 'react-icons/ri';

interface Props {
  showSite?: boolean;
  totalPages: number;
  sharedDate: string;
  currentPage: number;
  position: 'top' | 'bottom';
}

const SharedOrderHeader = ({ showSite, totalPages, sharedDate, currentPage, position }: Props) => {
  return (
    <>
      <S.OrderPageRow position={position} show>
        <S.Text position='flex-start'>
          Compartilhado em
          <RiCalendarTodoLine size={15} />
          <S.BoldText position='flex-start'>{sharedDate}</S.BoldText>
        </S.Text>

        <S.Text position='center'>{showSite && 'www.bateforte.com.br'}</S.Text>

        <S.BoldText position='flex-end'>
          <RiBookReadLine size={15} />
          Página {currentPage} de {totalPages}
        </S.BoldText>
      </S.OrderPageRow>

      <S.OrderPageRow position={position}>
        <S.Text position='flex-start'>
          Compartilhado em
          <RiCalendarTodoLine size={15} />
          <S.BoldText position='flex-start'>{sharedDate}</S.BoldText>
        </S.Text>

        <S.Text position='center'>{showSite && window.location.host}</S.Text>

        <S.BoldText position='flex-end'>
          <RiBookReadLine size={15} />
          Página {currentPage} de {totalPages}
        </S.BoldText>
      </S.OrderPageRow>
    </>
  );
};

export default SharedOrderHeader;
